var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lane-planning"},[_c('PlanningWizard',{on:{"step":_vm.step}}),_c('IxVectorLayer',{attrs:{"features":_vm.featurePartialField,"vector-style":_vm.style,"layer-id":"partialFields","auto-focus":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }